import { Toggle } from "rsuite";
import styled from "styled-components";

export default styled(Toggle)`
  .rs-toggle-presentation {
    background-color: ${({ bgCol }) =>
      bgCol ? "#40bf7f !important" : "#CED2DA"};
  }
`;
